import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="settlement-letter-acceptance"
export default class extends Controller {
  static targets = ["button", "container", "overlay"]

  showOverlay() {
    this.overlayTarget.classList.remove("hidden");
  }

  hideOverlay() {
    this.overlayTarget.classList.add("hidden");
  }
}
